document.addEventListener("DOMContentLoaded", function() {
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const answer = question.nextElementSibling; // Get the div after the question button (which is the answer)
      // Toggle the display style between 'none' and 'block'
      answer.style.display = (answer.style.display === 'none' || answer.style.display === '') ? 'block' : 'none';
    });
  });
});
